import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Drawer, Button, Icon, Input } from 'antd';
import store from '@/stores';
import { useLocalStore, useObserver } from 'mobx-react';
import { getAddress } from '@/service/common';
import './index.scss';

const DrawerWrap = props => {
  const {
    visible,
    onOk,
    ...rest
  } = props;

  const [cityList, setCityList] = useState([]);

  const getCity = async () => {
    let res = await getAddress({
      pageNum: 1,
      pageSize: 1000,
    });
    console.log(res, 'res');
    if (res.code === 0) {
      const cityArr = res.result.data.sortCityMap;
      let arr = [];
      for (let key in cityArr) {
        arr.push({
          cityIndex: key,
          citys: cityArr[key],
        })
      };
      setCityList(arr);
    }
  };

  useEffect(() => {
    getCity();
  }, []);

  return (
    <Drawer
      className="drawer-choose-city"
      visible={visible}
      title='选择城市'
      width="100%"
      destroyOnClose
      closable={false}
      {...rest}
    >

      <div className="choose-city">
        <div className='city-content'>
          {
            cityList.map((item, index) => (
              <div className='city-item' key={index}>
                <div className='city-item-index'>
                  {item.cityIndex}
                </div>
                <div className='city-item-list-wrap'>
                  {
                    item.citys.map((info, j) => (
                      <div className='city-item-list' key={j} onClick={() => {
                        onOk(info);
                      }}>
                        {info.cityName}
                      </div>
                    ))
                  }
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </Drawer>
  );
};

DrawerWrap.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  onOk: PropTypes.func,
};

DrawerWrap.defaultProps = {
  visible: false,
  onCancel: () => { },
  onOk: () => { },
};

export default DrawerWrap;
